export function SettingsSectionTitle({ children, ...props }) {
  return (
    <div className="SettingsSectionTitle" {...props}>
      {children}
    </div>
  );
}

export function SettingItem({ label, right, children }) {
  return (
    <div className="SettingItem">
      <div className="SettingLeft">
        <div className="SettingLabel">{label}</div>
        {children ? <div className="SettingHelp">{children}</div> : null}
      </div>
      <div className="SettingRight">{right}</div>
    </div>
  );
}

export function Toggle({ checked, onChange, disabled, ariaLabel }) {
  return (
    <label className={`Toggle ${disabled ? 'is-disabled' : ''}`} aria-label={ariaLabel}>
      <input type="checkbox" checked={Boolean(checked)} onChange={(e) => onChange?.(Boolean(e.target.checked))} disabled={disabled} />
      <span className="ToggleTrack" aria-hidden="true">
        <span className="ToggleThumb" />
      </span>
    </label>
  );
}
